module.exports = __webpack_public_path__ + "static/app-1477799514b54788686d4c9d8a400683.png";